const _excluded = ["selectedItems", "disableClear"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Placeholder, DefaultFooter } from '../layout';
export const defaultRenderPlaceholder = props => /*#__PURE__*/React.createElement(Placeholder, props);
export const defaultRenderFooter = _ref => {
  let {
      selectedItems,
      disableClear = !selectedItems || selectedItems.length === 0
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DefaultFooter, _extends({
    selectedItems: selectedItems,
    disableClear: disableClear
  }, props));
};
//# sourceMappingURL=defaultRenderers.js.map